<template>
  <div class="automacao-wizard__escolha">
    <button
      v-if="pulado"
      type="button"
      class="automacao-wizard__continuar"
      @click="reabrir"
    >
      Adicionar passo
    </button>
    <template v-if="!pulado">
      <p class="automacao-wizard__pergunta">{{ pergunta }}</p>
      <div v-if="mostraTipos" class="automacao-wizard__grade">
        <button
          type="button"
          class="automacao-wizard__opcao automacao-wizard__opcao--condicao"
          @click="escolherTipo('condicao')"
        >
          <i class="fas fa-filter" aria-hidden="true"></i>
          <strong>Condição</strong>
        </button>
        <button
          type="button"
          class="automacao-wizard__opcao automacao-wizard__opcao--acao"
          @click="escolherTipo('acao')"
        >
          <i class="fas fa-bolt" aria-hidden="true"></i>
          <strong>Ação</strong>
        </button>
      </div>
      <button
        v-if="mostraTipos"
        type="button"
        class="automacao-wizard__pular"
        @click="pular"
      >
        Pular
      </button>
      <div v-if="mostraItens">
        <button
          v-if="modo !== 'gatilho'"
          type="button"
          class="automacao-wizard__voltar"
          @click="voltar"
        >
          Voltar
        </button>
        <div class="automacao-wizard__grade">
          <button
            v-for="item in itens"
            :key="item.id"
            type="button"
            class="automacao-wizard__opcao"
            :class="'automacao-wizard__opcao--' + secaoId"
            :disabled="!item.disponivel"
            @click="escolherItem(item.id)"
          >
            <i :class="item.icone" aria-hidden="true"></i>
            <strong>{{ item.titulo }}</strong>
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { secoesBlocos } from './automacao-blocos'

export default {
  name: 'AutomacaoWizardAdd',
  props: {
    pergunta: {
      type: String,
      required: true,
    },
    modo: {
      type: String,
      default: 'seguinte',
    },
  },
  data() {
    return {
      pulado: false,
      etapa: this.modo === 'gatilho' ? 'itens' : 'tipo',
      secaoId: this.modo === 'gatilho' ? 'gatilho' : '',
    }
  },
  computed: {
    mostraTipos() {
      return this.etapa === 'tipo'
    },
    mostraItens() {
      return this.etapa === 'itens'
    },
    itens() {
      const secao = secoesBlocos().find((bloco) => bloco.id === this.secaoId)
      if (!secao) {
        return []
      }
      return secao.itens
    },
  },
  methods: {
    escolherTipo(id) {
      this.secaoId = id
      this.etapa = 'itens'
    },
    voltar() {
      this.secaoId = ''
      this.etapa = 'tipo'
    },
    pular() {
      this.pulado = true
      this.secaoId = ''
      this.etapa = 'tipo'
      this.$emit('pular')
    },
    reabrir() {
      this.pulado = false
      this.etapa = this.modo === 'gatilho' ? 'itens' : 'tipo'
      this.secaoId = this.modo === 'gatilho' ? 'gatilho' : ''
    },
    escolherItem(tipo) {
      this.$emit('adicionar', tipo)
    },
  },
}
</script>
